/**
 * Created by hp on 2017/6/27.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dialog} from 'react-weui';
import axios from 'axios';
import qr from 'qr-encode';
import Config from '../../config';

import '../../styles/channel/ChannelDialog.css';

class ChannelDialog extends Component {
    constructor() {
        super();
        this.handleHideDiscountDialog = this.handleHideDiscountDialog.bind(this);
        this.handleSubmitDiscount = this.handleSubmitDiscount.bind(this);
        this.handleDiscountCode = this.handleDiscountCode.bind(this);
        this.handleSubscribe = this.handleSubscribe.bind(this);
        this.handleHidePushDialog = this.handleHidePushDialog.bind(this);
        this.handleSubmitPush = this.handleSubmitPush.bind(this);
        this.handleHideDelChannelDialog = this.handleHideDelChannelDialog.bind(this);
        this.handleDelChannel = this.handleDelChannel.bind(this);
        this.handleDelChannelSuccess = this.handleDelChannelSuccess.bind(this);
        this.state = {
            discountCode: '',
            errorMsg: '',
            dialogStyle: {
                discountStyle: {
                    title: '请输入优惠码',
                    buttons: [
                        {
                            type: 'default',
                            label: '取消',
                            onClick: this.handleHideDiscountDialog
                        },
                        {
                            type: 'primary',
                            label: '确定',
                            onClick: this.handleSubmitDiscount
                        }
                    ]
                },
                subscribedStyle: {
                    title: '长按二维码扫码预约专栏， 接受开课提醒',
                    buttons: [
                        {
                            type: 'default',
                            label: '我不需要开课提醒',
                            onClick: this.handleSubscribe
                        }
                    ]
                },
                pushStyle: {
                    title: '',
                    normalButtons: [
                        {
                            type: 'default',
                            label: '取消',
                            onClick: this.handleHidePushDialog
                        },
                        {
                            type: 'primary',
                            label: '确定',
                            onClick: this.handleSubmitPush
                        }
                    ],
                    closeButtons: [
                        {
                            type: 'default',
                            label: '关闭',
                            onClick: this.handleHidePushDialog
                        }
                    ]
                },
                delChannelStyle: {
                    title: '荔枝温馨提示',
                    buttons: [
                        {
                            type: 'default',
                            label: '取消',
                            onClick: this.handleHideDelChannelDialog
                        },
                        {
                            type: 'primary',
                            label: '确定',
                            onClick: this.handleDelChannel
                        }
                    ]
                },
                delChannelSuccessStyle: {
                    title: '荔枝温馨提示',
                    buttons: [
                        {
                            type: 'default',
                            label: '关闭',
                            onClick: this.handleDelChannelSuccess
                        }
                    ]
                }
            }
        }
    }

    handleSubmitPush() {
        const {channel} = this.props;
        axios.post(`/api/channel/${channel.id}/push`).then(res => {
            if (res.data.code === 0) {
                this.context.page.showAlert('专栏推送成功');
                this.handleHidePushDialog();
            } else {
                this.context.page.showAlert(res.data.msg);
            }
        });
    }

    handleHidePushDialog() {
        this.props.dispatch({type: 'CHANNEL_HIDE_PUSH_DIALOG'});
    }

    handleHideDiscountDialog() {
        this.props.dispatch({type: 'CHANNEL_HIDE_DISCOUNT_DIALOG'});
        this.setState({errorMsg: ''});
    }

    handleSubmitDiscount() {
        const {discountCode} = this.state;
        const {channel} = this.props;
        axios.post(`/api/channel/${channel.id}/discount/${discountCode}/check`).then(res => {
            if (res.data.code === 0) {
                this.props.dispatch({
                    type: 'CHANNEL_SET_DISCOUNT',
                    payload: res.data.data.discount
                });
                this.props.dispatch({
                    type: 'CHANNEL_HIDE_DISCOUNT_DIALOG'
                });
                this.props.dispatch({
                    type: 'CHANNEL_SHOW_PAY_PANEL'
                });
            } else {
                this.setState({errorMsg: res.data.msg});
            }
        });
    }

    handleDiscountCode(e) {
        this.setState({discountCode: e.target.value});
    }

    handleSubscribe() {
        const {channel} = this.props;
        this.props.dispatch({
            type: 'CHANNEL_HIDE_SUBSCRIBED_DIALOG'
        });
        axios.post(`/api/channel/${channel.id}/subscribe`).then(res => {
            if (res.data.code !== 0) {
                return this.context.page.showAlert(res.data.msg);
            }
            this.context.page.showAlert('该专栏的所有课程已经预约成功，后续更新课程会为你自动预约。');
            this.props.dispatch({type: 'CHANNEL_SUBSCRIBED_CHANNEL'})
        });
    }

    handleHideDelChannelDialog() {
        this.props.dispatch({type: 'CHANNEL_HIDE_DEL_CHANNEL_DIALOG'});
    }

    handleDelChannel() {
        const {channel} = this.props;

        axios.post(`/api/channel/${channel.id}/delete`).then(res => {
            this.handleHideDelChannelDialog();
            if (res.data.code !== 0) {
                return this.context.page.showAlert(res.data.msg);
            }
            this.props.dispatch({type: 'CHANNEL_SHOW_DEL_CHANNEL_SUCCESS_DIALOG'});
        });
    }

    handleDelChannelSuccess() {
        const {liveroomId} = this.props;
        window.location = `/liveroom/${liveroomId}`;
    }

    render() {
        const {discountStyle, subscribedStyle, pushStyle, delChannelStyle, delChannelSuccessStyle} = this.state.dialogStyle;
        const {discountCode, errorMsg} = this.state;
        const {showDiscountDialog, showSubscribedDialog, subscribedQrcode, showPushDialog, pushObj, showDelChannelDialog, showDelChannelSuccessDialog} = this.props;

        pushStyle.buttons = pushObj.canPush ? pushStyle.normalButtons : pushStyle.closeButtons;
        return (
            <div className="channel-dialog">
                <Dialog title={discountStyle.title} buttons={discountStyle.buttons} show={showDiscountDialog}>
                    <input value={discountCode} pattern="[0-9]*" onChange={this.handleDiscountCode}/>
                    {errorMsg &&
                    <p className="error">{errorMsg}</p>
                    }
                </Dialog>

                <Dialog className="subscribe" type="ios" title={subscribedStyle.title} buttons={subscribedStyle.buttons} show={showSubscribedDialog}>
                    <img className="qrcode-img" src={qr(subscribedQrcode)} alt="channelQrcode"/>
                </Dialog>

                <Dialog className="push" title={"还剩" + pushObj.pushTime + "次推送机会"} buttons={pushStyle.buttons} show={showPushDialog}>
                    {pushObj.msg}
                </Dialog>

                <Dialog className="delChannel" title={delChannelStyle.title} buttons={delChannelStyle.buttons} show={showDelChannelDialog}>
                    你确定要删除专栏？(注意：该专栏以及该专栏下的所有课程将会被删除)
                </Dialog>

                <Dialog className="delChannelSuccess" title={delChannelSuccessStyle.title} buttons={delChannelSuccessStyle.buttons} show={showDelChannelSuccessDialog}>
                    删除专栏成功，点击关闭回到直播间
                </Dialog>
            </div>
        )
    }
}

ChannelDialog.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    channel: state.channel.channel,
    showDiscountDialog: state.channel.showDiscountDialog,
    showSubscribedDialog: state.channel.showSubscribedDialog,
    subscribedQrcode: state.channel.subscribedQrcode,
    showPushDialog: state.channel.showPushDialog,
    showDelChannelDialog: state.channel.showDelChannelDialog,
    showDelChannelSuccessDialog: state.channel.showDelChannelSuccessDialog,
    pushObj: state.channel.pushObj,
    liveroomId: state.channel.liveroom.id,
}))(ChannelDialog)



// WEBPACK FOOTER //
// ./src/components/channel/ChannelDialog.js